import React, { useState } from 'react';

export default function Notenrechner() {
  const [erfahrung, setErfahrung] = useState(5.0);
  const [praktisch, setPraktisch] = useState(4.5);
  const [berufskunde, setBerufskunde] = useState(4.8);
  const [abu, setAbu] = useState(5.0);

  // Beispielhafte Notenberechnung gemäss Schweizer Bildungsverordnung
  const gesamtnote = (
    (parseFloat(erfahrung) * 0.2) +
    (parseFloat(praktisch) * 0.4) +
    (parseFloat(berufskunde) * 0.2) +
    (parseFloat(abu) * 0.2)
  ).toFixed(2);

  const bestanden = parseFloat(gesamtnote) >= 4.0 && parseFloat(praktisch) >= 4.0;

  return (
    <div className="bg-[#141c2e] border border-slate-800 rounded-2xl p-6 md:p-8 my-8 shadow-2xl">
      <h2 className="text-2xl font-black text-white mb-2">🧮 QV & LAP Notenrechner Schweiz</h2>
      <p className="text-slate-400 text-sm mb-6">
        Berechne deine voraussichtliche Gesamtnote im Qualifikationsverfahren (QV) gemäss Schweizer Bildungsverordnung.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div>
          <label className="block text-xs font-bold text-slate-300 mb-1">Erfahrungsnote (Schule)</label>
          <input
            type="number"
            min="1"
            max="6"
            step="0.1"
            value={erfahrung}
            onChange={(e) => setErfahrung(e.target.value)}
            className="w-full bg-[#0b1329] border border-slate-700 text-white p-3 rounded-xl font-bold"
          />
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-300 mb-1">Praktische Arbeit (VPA / IPA)</label>
          <input
            type="number"
            min="1"
            max="6"
            step="0.1"
            value={praktisch}
            onChange={(e) => setPraktisch(e.target.value)}
            className="w-full bg-[#0b1329] border border-slate-700 text-white p-3 rounded-xl font-bold"
          />
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-300 mb-1">Berufskunde Prüfung</label>
          <input
            type="number"
            min="1"
            max="6"
            step="0.1"
            value={berufskunde}
            onChange={(e) => setBerufskunde(e.target.value)}
            className="w-full bg-[#0b1329] border border-slate-700 text-white p-3 rounded-xl font-bold"
          />
        </div>
        <div>
          <label className="block text-xs font-bold text-slate-300 mb-1">Allgemeinbildung (ABU)</label>
          <input
            type="number"
            min="1"
            max="6"
            step="0.1"
            value={abu}
            onChange={(e) => setAbu(e.target.value)}
            className="w-full bg-[#0b1329] border border-slate-700 text-white p-3 rounded-xl font-bold"
          />
        </div>
      </div>

      <div className={`p-4 rounded-xl border flex items-center justify-between ${bestanden ? 'bg-emerald-950/40 border-emerald-500/50 text-emerald-400' : 'bg-rose-950/40 border-rose-500/50 text-rose-400'}`}>
        <div>
          <div className="text-xs uppercase font-bold tracking-wider">Errechnete Gesamtnote</div>
          <div className="text-3xl font-black mt-1">{gesamtnote}</div>
        </div>
        <div className="text-right font-extrabold text-sm uppercase px-3 py-1.5 rounded-lg border border-current">
          {bestanden ? '✓ Bestanden' : '✗ Nicht bestanden'}
        </div>
      </div>
    </div>
  );
}
